import React from 'react'
import { logout } from '../Auth.ducks'
import { connect } from 'react-redux';

function EtatAbonnement(props) {
  return (
    <main class="main-wrapper login-page">
      <div class="container-login">
        <form class="box-login" onSubmit={(e) => {
          e.preventDefault();
          props.logout();
        }}>
          <h5 class="mb-4">Votre compte semble désactivé<br /><br />Merci de vous adresser à l'administrateur de votre établissement pour regler le problème.</h5>
          <button type="submit" class="btn-gradient mt-4">Retour</button>
        </form>
      </div>
    </main>
  )
}
const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {
  logout
}

export default connect(mapStateToProps, mapDispatchToProps)(EtatAbonnement)